module.exports = __webpack_public_path__ + "img/mao-impedindo-blocos-de-derrubarem-outros-blocos.jpg";